import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs/index';
import { Person } from '../../core/model/central/person.model';
import { Reason } from '../../core/model/central/reason.model';
import { Strategy } from '../../core/model/central/strategy.model';

@Component({
    selector: 'patient-reminder-settings',
    templateUrl: './patient-reminder-settings.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PatientReminderSettingsComponent {
    @Input() selectedPatient: Person;
    @Input() strategies: Array<Strategy>;
    @Input() selectedPatientStrategy: Strategy;
    @Output() readonly strategyChanged: EventEmitter<any> = new EventEmitter<any>();

    subscriptions: Subscription = new Subscription();
    selectedStrategy: Strategy;

    constructor(private store: Store<Reason>) {
    }

    // TODO: Handle if selected strategy changes while on the page (e.g. patient strategy set to different strategy)
    // TODO: Ensure that effects will show dialog to accept change - or revert setting
}
